export const ENABLE_LAZY_COMMENTS = true;
export const ENABLE_IO_SCROLL = true;
export const ENABLE_SCROLL_TO_TOP = true;
export const ENABLE_PROGRESSIVE_SLICE = true;
export const ENABLE_DEFERRED_AUX_FETCHES = true;
export const ENABLE_FEED_COMMENT_PREVIEW = true;

const paginationFlagEnv =
  typeof process !== "undefined"
    ? process.env.NEXT_PUBLIC_FEED_PAGINATION_V2 ??
      process.env.REACT_APP_FEED_PAGINATION_V2
    : undefined;

export const FEED_PAGINATION_V2 =
  paginationFlagEnv === undefined ? true : paginationFlagEnv === "true";
